/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./SalaryDetail.css"; // Import the CSS file

const SalaryDetail = () => {
  const { id } = useParams(); // Get ID from URL parameters
  const [salary, setSalary] = useState();
  const [showTime, setShowTime] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  // For now, we'll hardcode areaId as it's not in the URL, but it should come from a dynamic source if available.

  useEffect(() => {
    if (id) {
      const [salaryIdFromUrl, phoneNumberFromUrl] = id.split("-");
      if (salaryIdFromUrl && phoneNumberFromUrl) {
        getSalaryById(salaryIdFromUrl, phoneNumberFromUrl);
      } else {
        // Handle invalid ID format, e.g., show an error message or redirect
        setSalary(null); // Or set an error state
      }
    }
  }, [id]);

  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h === 1 ? " giờ " : " giờ ") : "";
    var mDisplay = m > 0 ? m + (m === 1 ? " phút " : " phút ") : "";
    var sDisplay = s > 0 ? s + (s === 1 ? " giây" : " giây") : "";
    return hDisplay + mDisplay + sDisplay;
  }

  const formatMoneyVND = (money, noVND) => {
    if (money == null) {
      return "0" + (!noVND ? " VNĐ" : "");
    }
    return (
      money.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND",
      }) + (!noVND ? "" : "")
    );
  };

  const getSalaryById = async (salaryId, phoneNumber) => {
    try {
      const response = await fetch(
        `https://api.comnieuthienly.vn/api/personnel/salary/public/${salaryId}`,
        {
          method: "GET",
          headers: {
            "sec-ch-ua-platform": '"macOS"',
            Referer: "https://admin.comnieuthienly.vn/",
            "sec-ch-ua":
              '"Not)A;Brand";v="8", "Chromium";v="138", "Google Chrome";v="138"',
            "sec-ch-ua-mobile": "?0",
            "company-id": "1",
            "User-Agent":
              "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (
        data.data &&
        data.data.staff &&
        data.data.staff.phone_number === phoneNumber
      ) {
        setSalary(data.data);
      } else {
        setSalary(null); // Set salary to null if phone number doesn't match or data is invalid
      }
    } catch (error) {
      console.error("Error fetching salary data:", error);
      setSalary(null); // Set salary to null on error
    }
  };

  function getSupport() {
    return (salary?.supports ?? []).length !== 0
      ? (salary?.supports ?? [])
          .map((e) => e.value ?? 0)
          .reduce((v, e) => v + e)
      : 0;
  }

  const confirmSalaryTable = async () => {
    if (!salary || !salary.id) {
      setConfirmMessage("Không thể xác nhận bảng lương: Thiếu thông tin ID");
      return;
    }

    setConfirming(true);
    setConfirmMessage("");

    try {
      const response = await fetch(
        `https://api.comnieuthienly.vn/api/personnel/salary/public/${salary.id}`,
        {
          method: "PUT",
          headers: {
            "sec-ch-ua-platform": '"macOS"',
            Referer: "https://admin.comnieuthienly.vn/",
            "sec-ch-ua":
              '"Not)A;Brand";v="8", "Chromium";v="138", "Google Chrome";v="138"',
            "sec-ch-ua-mobile": "?0",
            "company-id": "1",
            "User-Agent":
              "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            confirm: true,
            staff_note: "Đã xác nhận từ hệ thống bảng lương",
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        setConfirmMessage("✅ Bảng lương đã được xác nhận thành công!");
        // Refresh salary data
        const [salaryIdFromUrl] = id.split("-");
        if (salaryIdFromUrl) {
          getSalaryById(salaryIdFromUrl, salary.staff.phone_number);
        }
      } else {
        setConfirmMessage(
          `❌ Lỗi: ${data.message || "Không thể xác nhận bảng lương"}`
        );
      }
    } catch (error) {
      console.error("Error confirming salary table:", error);
      setConfirmMessage("❌ Lỗi kết nối: Không thể xác nhận bảng lương");
    } finally {
      setConfirming(false);
    }
  };

  if (!salary) {
    return (
      <div className="loading-container">
        {salary !== null ? <div className="loader"></div> : <></>}
        <div>
          {salary === null
            ? "Bảng lương không tồn tại."
            : "Đang tải dữ liệu..."}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="salary-detail-page">
        <div className="header">
          <h2>
            Bảng lương {salary?.staff?.name} - {salary?.month || 0}-
            {salary?.year || 0}
          </h2>
        </div>
        <div className="content-section">
          <div className="form-group">
            <label>Tháng áp dụng:</label>
            <input
              value={`${salary?.month || 0}-${salary?.year || 0}`}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="section-title">Thời gian:</div>
          <div className="form-group">
            <label>Chức vụ:</label>
            <input
              value={salary?.staff?.position || ""}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Phòng ban:</label>
            <input
              value={salary?.staff?.department?.name || ""}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Chi nhánh:</label>
            <input
              value={salary?.area?.name || ""}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Ngày công chuẩn:</label>
            <input
              value={salary?.count_day_work ?? 0}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Giờ công chuẩn:</label>
            <input
              value={
                salary?.time_default
                  ? (salary.time_default / 3600).toFixed(2)
                  : 0
              }
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Giờ công thực tế:</label>
            <input
              value={secondsToHms(salary?.work_time || 0)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Giờ công chấm hộ, thêm giờ:</label>
            <input
              value={secondsToHms(
                (salary?.household_time ?? 0) + (salary?.add_time ?? 0)
              )}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Quên chấm công được duyệt:</label>
            <input
              value={secondsToHms(salary?.bonus_form_time || 0)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Nghỉ phép được duyệt:</label>
            <input
              value={secondsToHms(salary?.leave_form_time || 0)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Công tác được duyệt:</label>
            <input
              value={secondsToHms(salary?.trip_form_time || 0)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Tăng ca/thêm giờ được duyệt:</label>
            <input
              value={secondsToHms(salary?.over_form_time || 0)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Giờ làm lễ:</label>
            <input
              value={secondsToHms(salary?.ot_time || 0)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>

          {showTime ? (
            (salary?.shift_money ?? []).map((e, index) => (
              <div className="form-group" key={index}>
                <label style={{ color: "blue" }}>{e?.shift_name ?? ""}</label>
                <input
                  value={secondsToHms(e?.time || 0)}
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  readOnly
                />
              </div>
            ))
          ) : (
            <></>
          )}
          <div className="form-group total-row">
            <label
              style={{ fontWeight: "700", color: "blue" }}
              onClick={() => {
                setShowTime(!showTime);
              }}
            >
              TỔNG GIỜ CÔNG (Xem chi tiết):
            </label>
            <input
              value={secondsToHms(
                (salary?.work_time ?? 0) +
                  (salary?.leave_form_time ?? 0) +
                  (salary?.trip_form_time ?? 0) +
                  (salary?.bonus_form_time ?? 0) +
                  (salary?.over_form_time ?? 0) +
                  (salary?.ot_time ?? 0) +
                  (salary?.household_time ?? 0) +
                  (salary?.add_time ?? 0)
              )}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="separator"></div>
          <div className="section-title">THU NHẬP:</div>
          <div className="form-group">
            <label>Lương theo giờ công chuẩn:</label>
            <input
              value={formatMoneyVND(salary?.work_money ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương được chấm hộ, thêm giờ:</label>
            <input
              value={formatMoneyVND(
                (salary?.household_money ?? 0) + (salary?.add_money ?? 0),
                true
              )}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương quên chấm công:</label>
            <input
              value={formatMoneyVND(salary?.bonus_form_money ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương nghỉ phép:</label>
            <input
              value={formatMoneyVND(salary?.leave_form_money ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương công tác:</label>
            <input
              value={formatMoneyVND(salary?.trip_form_money ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương vị trí (P1):</label>
            <input
              value={formatMoneyVND(salary?.position_salary ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương năng lực (P2):</label>
            <input
              value={formatMoneyVND(salary?.support_productive ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>KPI đạt được:</label>
            <input
              value={formatMoneyVND(salary?.kpi_percent ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương kết quả (P3):</label>
            <input
              value={formatMoneyVND(salary?.support_result ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          {showTime ? (
            (salary?.shift_money ?? []).map((e, index) => (
              <div className="form-group" key={index}>
                <label style={{ color: "blue" }}>
                  {`${e?.shift_name ?? ""} - ${formatMoneyVND(
                    e?.money_shift ?? 0,
                    true
                  )}`}
                </label>
                <input
                  value={formatMoneyVND(e?.money ?? 0, true)}
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  readOnly
                />
              </div>
            ))
          ) : (
            <></>
          )}
          <div className="form-group total-row">
            <label
              style={{ fontWeight: "700", color: "blue" }}
              onClick={() => {
                setShowTime(!showTime);
              }}
            >
              Tổng lương theo giờ công thực tế (1) (Xem chi tiết):
            </label>
            <input
              value={formatMoneyVND(salary?.salary_with_kpi ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="separator"></div>
          <div className="form-group">
            <label>Lương tăng ca:</label>
            <input
              value={formatMoneyVND(salary?.over_form_money ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Lương làm lễ:</label>
            <input
              value={formatMoneyVND(salary?.ot_money ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group total-row">
            <label style={{ fontWeight: "700" }}>Tổng lương tăng ca (2):</label>
            <input
              value={formatMoneyVND(
                (salary?.over_form_money ?? 0) + (salary?.ot_money ?? 0),
                true
              )}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>

          <div className="separator"></div>
          <div className="form-group">
            <label>Cơm trưa (50%):</label>
            <input
              value={formatMoneyVND(salary?.pc_food ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Xăng xe (30%):</label>
            <input
              value={formatMoneyVND(salary?.pc_move ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Điện thoại (20%):</label>
            <input
              value={formatMoneyVND(salary?.pc_phone ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Thâm niên:</label>
            <input
              value={formatMoneyVND(salary?.seniority ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          {(salary?.supports ?? []).map((e, index) => (
            <div className="form-group" key={index}>
              <label>{e?.title ?? ""}</label>
              <input
                value={formatMoneyVND(e?.value ?? 0, true)}
                type="text"
                className="form-control"
                autoComplete="off"
                readOnly
              />
            </div>
          ))}
          <div className="form-group total-row">
            <label style={{ fontWeight: "700" }}>Tổng lương phụ cấp (3):</label>
            <input
              value={formatMoneyVND(
                (salary?.pc_food ?? 0) +
                  (salary?.pc_move ?? 0) +
                  (salary?.pc_phone ?? 0) +
                  (salary?.seniority ?? 0) +
                  getSupport(),
                true
              )}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>

          <div className="separator"></div>

          <div className="form-group total-row">
            <label style={{ fontWeight: "700" }}>Tạm ứng (4):</label>
            <input
              value={formatMoneyVND(salary?.total_bonus ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="separator"></div>
          <div className="form-group">
            <label>Cộng khác:</label>
            <input
              value={formatMoneyVND(salary?.another_plus ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Trừ khác:</label>
            <input
              value={formatMoneyVND(salary?.another_minus ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Trừ không đạt KPI đào tạo:</label>
            <input
              value={formatMoneyVND(salary?.education_kpi_minus ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group total-row">
            <label style={{ fontWeight: "700" }}>
              TỔNG THU NHẬP (1) + (2) + (3) + (4) + (5) + (6):
            </label>
            <input
              value={formatMoneyVND(salary?.salary_provisional ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="separator"></div>
          <div className="section-title">KHOẢN TRỪ:</div>
          <div className="form-group">
            <label>BHXH</label>
            <input
              value={formatMoneyVND(salary?.BHXH ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>BHYT</label>
            <input
              value={formatMoneyVND(salary?.BHYT ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>BHTN</label>
            <input
              value={formatMoneyVND(salary?.BHTN ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>

          <div className="form-group total-row">
            <label style={{ fontWeight: "700" }}>Bảo hiểm:</label>
            <input
              value={formatMoneyVND(
                (salary?.BHXH ?? 0) + (salary?.BHYT ?? 0) + (salary?.BHTN ?? 0),
                true
              )}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Công đoàn</label>
            <input
              value={formatMoneyVND(salary?.cong_doan ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="separator"></div>
          <div className="form-group">
            <label>Thuế</label>
            <input
              value={formatMoneyVND(salary?.tax ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Khác (Khoản phát sinh tính vào lương thực nhận)</label>
            <input
              value={formatMoneyVND(salary?.another ?? 0, true)}
              type="text"
              className="form-control"
              autoComplete="off"
              readOnly
            />
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          boxSizing: "border-box",
          paddingBottom: "20px",
          paddingLeft: "0",
          paddingRight: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="salary-receives-card">
          <span className="salary-receives-text">
            Lương thực nhận: {formatMoneyVND(salary?.salary ?? 0, true)} VNĐ
          </span>
        </div>
      </div>

      {/* Confirm Button Section - Bottom of page */}
      <div className="confirm-section-container">
        {salary?.confirm ? (
          // Hiển thị khi đã xác nhận
          <div className="confirmed-status-card">
            <div className="confirmed-icon-circle">
              <i className="fas fa-check"></i>
            </div>
            <h3 className="confirmed-title">
              Bảng lương đã được xác nhận
            </h3>
            <p className="confirmed-message">
              Cảm ơn bạn đã xác nhận bảng lương này!
            </p>
          </div>
        ) : (
          // Hiển thị nút xác nhận khi chưa xác nhận
          <>
            <div
              style={{
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              <h3
                style={{
                  color: "#333",
                  fontSize: "1.4rem",
                  fontWeight: "600",
                  margin: "0 0 5px 0",
                }}
              >
                Xác nhận bảng lương
              </h3>
              <p
                style={{
                  color: "#666",
                  fontSize: "0.95rem",
                  margin: "0",
                  maxWidth: "400px",
                }}
              >
                Nhấn nút bên dưới để xác nhận bảng lương đã được kiểm tra và phê
                duyệt
              </p>
            </div>

            <button
              onClick={confirmSalaryTable}
              disabled={confirming || !salary}
              style={{
                background: confirming
                  ? "#ccc"
                  : "linear-gradient(90deg, #28a745 0%, #20c997 100%)",
                color: "white",
                border: "none",
                borderRadius: "12px",
                padding: "18px 40px",
                fontSize: "18px",
                fontWeight: "700",
                cursor: confirming ? "not-allowed" : "pointer",
                boxShadow: "0 6px 20px rgba(40, 167, 69, 0.3)",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                minWidth: "250px",
                justifyContent: "center",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
              onMouseOver={(e) => {
                if (!confirming) {
                  e.target.style.transform = "translateY(-3px)";
                  e.target.style.boxShadow =
                    "0 8px 25px rgba(40, 167, 69, 0.4)";
                }
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 6px 20px rgba(40, 167, 69, 0.3)";
              }}
            >
              {confirming ? (
                <>
                  <div
                    style={{
                      width: "24px",
                      height: "24px",
                      border: "3px solid #ffffff",
                      borderTop: "3px solid transparent",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  ></div>
                  Đang xác nhận...
                </>
              ) : (
                <>
                  <i
                    className="fas fa-check-circle"
                    style={{ fontSize: "20px" }}
                  ></i>
                  Xác nhận bảng lương
                </>
              )}
            </button>
          </>
        )}

        {confirmMessage && (
          <div
            style={{
              padding: "18px 25px",
              borderRadius: "10px",
              maxWidth: "500px",
              textAlign: "center",
              fontWeight: "600",
              fontSize: "16px",
              backgroundColor: confirmMessage.includes("✅")
                ? "#d4edda"
                : "#f8d7da",
              color: confirmMessage.includes("✅") ? "#155724" : "#721c24",
              border: `2px solid ${
                confirmMessage.includes("✅") ? "#c3e6cb" : "#f5c6cb"
              }`,
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              animation: "fadeIn 0.5s ease-in-out",
            }}
          >
            {confirmMessage}
          </div>
        )}
      </div>
    </>
  );
};

export default SalaryDetail;
